import React from 'react';
import { WorkflowCanvas } from '../components/Workflow/WorkflowCanvas';

const CreateWorkflow = () => {
  return (
    <div className="flex h-full min-h-0 bg-paper">
      <div className="flex-1 flex flex-col min-h-0 min-w-0">
        <WorkflowCanvas />
      </div>
    </div>
  );
};

export default CreateWorkflow;
